import Config from 'config/settings';
import { Controller } from 'core/Controller';
import { SectionType, AboutSectionType, ViewType } from 'app/data/Enums';

import { ScrollbarController } from 'app/chrome/scrollbar/ScrollbarController';
import { VerticalDragController } from 'app/chrome/verticaldrag/VerticalDragController';

import { HistoryStateModel } from 'app/model/HistoryStateModel';

import { Events } from 'core/events/Events';
import { AppEvents } from 'app/events/AppEvents';
import { ViewReadyEvent } from 'app/events/ViewReadyEvent';
import { NavMenuController } from 'app/chrome/navmenu/NavMenuController';
import DelayHelper from 'utils/timers';
import { PixiController } from 'app/services/PixiController';
import { Simple } from 'utils/analytics';
import fastdom from 'fastdom';
import { UIController } from 'app/views/ui/UIController';

/** Controller to manage */
export class AboutController extends Controller {
	//AJAX Loaded HTML
	private _active: boolean = false;

	private _html: any = {};
	private _mainHTMLInjected: boolean = false;
	private _allHTMLLoaded: boolean = false;
	private _sectionHTMLInjected: boolean = false;
	private _injectionQued: boolean = false;
	private _internalHTMLInjectTimerFlag: boolean = false;

	private _$subsections: any = {};
	private _$closeButton: HTMLElement;
	private _$closeButtonSVG: SVGElement;

	private _aboutSection: AboutSectionType;
	private _state: HistoryStateModel;

	private _scrollbar: ScrollbarController;
	private _pixiController: PixiController;
	private _ui: UIController;

	private _timeouts: any = {};
	private _tweens: any = {};
	private _intervals: any = {};
	private _deeplink: boolean = false;
	private _lockScrollUpdate: boolean = false;
	private _scrollProgress: number = 0;

	private _scrollFixInterval: number;

	private readonly ABOUTSECTIONS = ['info', 'studio', 'jobs', 'contact', 'what-we-do', 'our-process'];
	private readonly ABOUTSECTIONS_TITLES = {
		info: 'About Us',
		studio: 'Studio',
		jobs: 'Jobs',
		contact: 'Contact',
		whatWeDo: 'What we do',
		ourProcess: 'Our Processes'
	};

	//Init is only called if the section is deep linked to:
	public init(): void {
		//Info section is active loaded page so flag this
		this._active = true;

		//Set HTML to blank value to flag this section is loaded
		this._html[this._aboutSection] = '';
		this._mainHTMLInjected = true;

		//Set the opening state to the homepage:
		let openingState: HistoryStateModel = {
			section: SectionType.ABOUT,
			subsection: this._aboutSection,
			title: this.ABOUTSECTIONS_TITLES[this._aboutSection],
			href: `/${this._aboutSection}`
		};
		Events.dispatch(AppEvents.SET_INTIAL_STATE, openingState);

		Simple.event('deeplink', { section: SectionType.ABOUT, subsection: this._aboutSection });

		this.get('ui').setAboutDeeplink();

		//Trigger timer. This is stop internal HTML being set to quickly on incorrect section. If its too quick the Google can process the dyanmic content
		this._internalHTMLInjectTimerFlag = true;
		setTimeout(() => {
			this._internalHTMLInjectTimerFlag = false;
			if (this._allHTMLLoaded && !this._sectionHTMLInjected) {
				this._injectSectionsHTML();
				this.get('navMenu').show();
			}
		}, 5000);

		this._deeplink = true;
		(this.get('navMenu') as NavMenuController).initForAboutDeeplink(openingState);

		setTimeout(() => {
			this.show(null, true, true);
		}, 500);
	}

	//Routes
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------

	/** About Deeplink */
	public info(): void {
		this._aboutSection = AboutSectionType.INFO;
		this.init();
	}
	/** Studio Deeplink */
	public studio(): void {
		this._aboutSection = AboutSectionType.STUDIO;
		this.init();
	}
	/** Jobs Deeplink */
	public jobs(): void {
		this._aboutSection = AboutSectionType.JOBS;
		this.init();
	}
	/** Contact Deeplink */
	public contact(): void {
		this._aboutSection = AboutSectionType.CONTACT;
		this.init();
	}

	public ourProcess(): void {
		this._aboutSection = AboutSectionType.OUR_PROCESS;
		this.init();
	}

	public whatWeDo(): void {
		this._aboutSection = AboutSectionType.WHAT_WE_DO;
		this.init();
	}

	//Public
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------

	//Getters
	//-------------------------------------------------
	public isReadyToView(state: HistoryStateModel = null): boolean {
		//Check if the subsection has been loaded and is ready to view:
		if (!this._sectionHTMLInjected) {
			this._injectSectionsHTML();
			return false;
		}
		return true;
	}

	//TODO, legacy hack so remove.
	public readyForDeeplink(): boolean {
		return this.isReadyToView();
	}

	//Setters
	//-------------------------------------------------------
	/** Set contoller depencides */
	public setControllers(
		scrollbar: ScrollbarController,
		verticalDrag: VerticalDragController,
		PixiController: PixiController,
		uiController: UIController
	): void {
		this._scrollbar = scrollbar;
		this._pixiController = PixiController;
		this._ui = uiController;
	}

	/** DOReady auto event */
	public DOMReady(): void {
		//Set the active section to DOM records:
		if (this._active) {
			this._$subsections[this._aboutSection] = this.container.querySelector(`.info__subsection.-${this._aboutSection}`);
			this.resize();
		}

		this._$closeButton = document.querySelector('.ui_close__button');

		if (this._$closeButton) {
			this._$closeButtonSVG = this._$closeButton.querySelector('svg');
		}
	}

	/** Reset ready to show */
	public reset(): void {
		this._resetIntervalsAndAnimations();
	}

	public resetSection() {
		this._aboutSection = null;
	}

	public forceSection(aboutSection: string) {
		this.show();
	}

	/** Resize, fix container height */
	public resize(): void {
		if (!this._aboutSection || !this._$subsections[this._aboutSection]) {
			return;
		}
	}

	/** Tick function */
	public tick(): void {}

	/** Pause when menu is shown */
	public pause(): void {
		return;
		if (this.container) {
			gsap.TweenMax.to([this.container], 0.45, { scale: 1.2, ease: gsap.Power3.easeOut });
		}
	}

	/** Pause when menu is hidden */
	public unpause(): void {
		return;
		if (this.container) {
			gsap.TweenMax.to([this.container], 0.45, { scale: 1, ease: gsap.Power3.easeOut });
		}
	}

	/** Que section up (when nav menu is opened) **/
	public que(): void {
		if (!this._mainHTMLInjected) {
			this._createDOMStructure();
		} else if (!this._mainHTMLInjected && this._allHTMLLoaded) {
			this._injectSectionsHTML();
		} else if (!this._mainHTMLInjected) {
			this._injectionQued = true;
		}
	}

	//User has pressed back to main menu nav so slde right
	public backToMenuMainView(): void {
		gsap.TweenMax.to(this.container, 0.9, {
			x: '100%',
			ease: Config.standardEase,
			onComplete: () => {
				//When complete hide the info view as its no longer needed:
				//TODO add deactivation logic:
			}
		});
	}

	public gotoAboutSubsetion(section: AboutSectionType): void {
		this.onNavMenuPressItemPress(this._getIndexBySection(section));
	}

	/** Item has been pressed on main menu while Info section
	 *  This most likely because of desktop view and retaining them menu
	 */
	public onNavMenuPressItemPress(index: number): void {
		this._onPagingClick(index, true);
	}

	/** Menu has been closed with INFO open. So hide this */
	public backToParallax(): void {
		this._hideAboutAfterSlideOff();
		this._scrollbar.setActive(false);
	}

	private _hideAboutTimeout;
	private _hideAboutAfterSlideOff() {
		this._clearHideAboutTimeout();
		this._hideAboutTimeout = setTimeout(() => {
			fastdom.mutate(() => {
				if (this.container) {
					(this.container as HTMLElement).style.display = 'none';
				}
			});

			this._scrollbar.resetToZero();
		}, 700);
	}

	private _clearHideAboutTimeout() {
		if (this._hideAboutTimeout) {
			clearTimeout(this._hideAboutTimeout);
		}
		this._hideAboutTimeout = null;
	}

	public showForDeepLink(): void {
		return;
		console.log('About Controller showForDeepLink');
		if (this._deeplink) {
			(this.get('navMenu') as NavMenuController).showForAboutDeepLink();
		}
	}

	public scroll(windowY: number): void {
		if (this._active) {
			this.updateScrollProgress();

			clearTimeout(this._scrollFixInterval);

			this._scrollFixInterval = setTimeout(() => {
				this._scrollFixInterval = null;
				this.updateScrollProgress();
			}, 100);
		}
	}

	private updateScrollProgress(): void {
		if (this._lockScrollUpdate) {
			return;
		}

		this._scrollProgress = this._scrollbar.getRealProgress();
		this._setScrollProgress(this._scrollProgress);
	}

	/** Show after preload, or when section changes */
	public show(oldState: HistoryStateModel = null, slide: boolean = true, force = false): void {
		//setState will always be set before show is calle, so we have to state the view should be in
		//So check if the action came from nav menu. This means switching depth, sliding scross and then seting the menu to be closed
		//This will be the most common use case!!

		if (this._deeplink) {
			this._ui.showUi();
		}

		if (this._deeplink && !force) {
			return;
		}

		this._active = true;

		(this.container as HTMLElement).style.visibility = 'visible';
		(this.container as HTMLElement).style.display = 'block';

		this._clearHideAboutTimeout();

		console.log('window.scroll 0,0');
		window.scroll(0, 0);
		this._setScrollProgress(0);

		this._pixiController.setAllowSlowFrameCheck(false);

		console.log('this._state', this._state);

		if (this._state.fromMenu) {
			this._getIndexBySection(this._aboutSection);

			let sectionTarget: HTMLElement = this._$subsections[this._state.subsection];
			this.resize();

			//Reset opacity on the
			gsap.TweenMax.set(sectionTarget, { autoAlpha: 1 });

			this._showActiveSubsection(sectionTarget);
			this.DOM.addClass(this.container, '-abovemenu');


			this._timeouts.activateScrollbar = DelayHelper.setTimeout(() => {
				this._scrollbar.setFocus(sectionTarget, 0, sectionTarget.querySelector('.info__subsection__content'));
				this._scrollbar.setActive(true);
			}, 1000);

			this._timeouts.resetNav = DelayHelper.setTimeout(() => Events.dispatch(AppEvents.RESET_NAV_MENU), 1000);
			this._timeouts.resetZindex = DelayHelper.setTimeout(
				() => this.DOM.removeClass(this.container, '-abovemenu'),
				1500
			);

			return;
		}

		//Deep link:
		this._changeScrollFocus();
		this._scrollbar.setActive(true);
		this.resize();
	}

	public hide(newState: HistoryStateModel = null): void {
		console.log('AboutController.hide()');

		this.get('Pixi').unpause();
		setTimeout(() => {
			this._setScrollProgress(0, true);
		}, 600);

		DelayHelper.clearTimeout(this._timeouts.activateScrollbar);
		DelayHelper.clearTimeout(this._timeouts.resetNav);
		DelayHelper.clearTimeout(this._timeouts.resetZindex);
	}

	public resetScrollProgress() {
		this._setScrollProgress(0, true);
	}

	/**
	 * History state has been changed by a user action
	 * @param {HistoryStateModel} state - The current state of the app
	 */
	public setState(state: HistoryStateModel): void {
		this._state = state;
		this._aboutSection = this._state.subsection as AboutSectionType;
		this._getIndexBySection(this._aboutSection);
	}

	/**
	 * History state has been moved to go move inside the info section tions so just internal features to change state
	 * @param {HistoryStateModel} state - The current state of the app
	 */
	public subsectionStateChange(state: HistoryStateModel): void {
		if (state.subsection === 'menu') {
			(this.get('NavMenu') as NavMenuController).historyBackToMenu();
			this._aboutSection = null;
			this._state = state;
			return;
		}

		let oldStateSubsection = this._state.subsection;
		this._state = state;
		let sectionIndex: number = this._getIndexBySection(state.subsection as AboutSectionType);
		//Simulate a tab click. If coming from the nav menu delay this allow menu to transition out
		this.get('NavMenu').setState(this._state);
		this._onPagingClick(sectionIndex, true);

		if (oldStateSubsection === 'menu') {
			(this.get('NavMenu') as NavMenuController).historyBackToInfoFromMenu();
		}
	}

	/** HTML has loaded from external, so set to local store:
	 * @param {string} html - the raw HTML as a string
	 * @param {string} infoSection - the info section that the HTML is for
	 */
	public setHTML(html: string, section: AboutSectionType): void {
		this._html[section] = html;
		this._allHTMLLoaded = this._checkAllSectionHTMLLoaded();

		//Flag that the view is ready to view:
		if (this._allHTMLLoaded) {
			Events.dispatch(new ViewReadyEvent({ view: ViewType.INFO }), { delay: 1 });
		}

		//If active then Inject the sections around the HTML loaded for the page. Also checked if injection has been requested but not possible (when menu is opned)
		if (this._allHTMLLoaded && (this._active || this._injectionQued)) {
			if (!this._internalHTMLInjectTimerFlag) {
				this._injectSectionsHTML();
			}
		}
	}

	/** Get info section title
	 * @param {AboutSectionType} infoSection - the info section
	 * @return {string} - Infosection title
	 */
	public getSubsectionTitle(section: AboutSectionType): string {
		return this.ABOUTSECTIONS_TITLES[section];
	}

	public historyBackToRichSection() {
		this._scrollbar.setActive(false);
		(this.get('NavMenu') as NavMenuController).historyBackToRichSection();
	}

	//Private
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------

	/** Check all HTML is loaded. */
	private _checkAllSectionHTMLLoaded(): boolean {
		let loaded: boolean = true;
		this.ABOUTSECTIONS.forEach((section: string) => {
			if (this._html[section] === null || this._html[section] === undefined) {
				loaded = false;
			}
		});
		return loaded;
	}

	/**
	 * Page is not deeplinked to generate the info section + paging + any generic elements required
	 * Only used when info section is not deep linked directly to (and HTML is served in that way)
	 */
	private _createDOMStructure(): void {
		let html: string = `<section class="about">
				<!--<div class='info__background'></div>-->
			</section>`;

		this.DOM.append(
			document.querySelector('body'),
			html,
			() => {
				this.container = document.querySelector('.about');
				this._injectSectionsHTML();
			},
			true
		);
		this._mainHTMLInjected = true;
	}

	/**  All subsections (about/studio/jobs/contact) have their html loaded, so inject into the section - called when navMenu is opened (as info section is a likely destination) */
	private _injectSectionsHTML(): void {
		if (this._deeplink) {
			this._sectionHTMLInjected = true;
			this._coreHTMLReady();
			return;
		}

		//If already injected then short circuit
		if (this._sectionHTMLInjected) {
			return;
		}

		//If all sections are not loaded que injection
		if (!this._allHTMLLoaded) {
			this._injectionQued = true;
			return;
		}

		this._injectionQued = false;

		//Build all the remaining subsections as one string and append into the .info section:
		var htmlString: string = '';
		Object.keys(this._html).forEach((key: string) => {
			//If active section then it will just be a blank string (as HTML is on main page load an not needed)

			let show = !this._deeplink || key === this._state.subsection;

			if (show && this._html[key] !== '') {
				htmlString += this._html[key];
			}
		});

		this.DOM.append(this.container, htmlString, () => {
			this._sectionHTMLInjected = true;
			this._coreHTMLReady();
		});
	}

	//** Show active subsection, hide all others 8/
	private _showActiveSubsection($target: HTMLElement): void {
		Object.keys(this._$subsections).forEach(($key) => {
			if (this._$subsections[$key] !== $target) {
				this._$subsections[$key].style.display = 'none';
			}
		});

		$target.style.display = 'block';
		gsap.TweenMax.set($target, { x: '0%' });
	}

	/** Core HTML ready, so add paging events and set container refs */
	private _coreHTMLReady(): void {
		//set references to the container:
		this.container = document.querySelector('.about');
		this.ABOUTSECTIONS.forEach((section) => {
			if (!this._$subsections[section]) {
				this._$subsections[section] = this.container.querySelector(`.info__subsection.-${section}`);
			}
		});
	}

	/** On paging click then change info section */
	private _onPagingClick(index: number, byPassEvent: boolean = false): void {
		let section = this._getSectionByIndex(index);


		//If already in section then exit:
		if (this._aboutSection === section) {
			return;
		}

		//Switch subsection choosen item:
		let oldSection: AboutSectionType = this._aboutSection;
		let oldSectionIndex: number = this._getIndexBySection(this._aboutSection);
		this._aboutSection = section;

		//Animate across to new subsection
		let direction = oldSectionIndex > index ? 1 : -1;
		this._animateToSubsection(direction, oldSection);

		//Animate backgroud for minor parallax

		//If no section change event is needed then short circuit:
		if (byPassEvent) {
			return;
		}

		//Trigger event (Mainly so history state stuff can be managed)
		let newState: HistoryStateModel = {
			section: SectionType.ABOUT,
			subsection: this._aboutSection,
			title: this.ABOUTSECTIONS_TITLES[this._aboutSection],
			href: `/${this._aboutSection}/`,
			bypassTransitions: true
		};
		Events.dispatch(AppEvents.CHANGE_SECTION, newState);
	}

	/** Get the subsection by index */
	private _getSectionByIndex(index: number): AboutSectionType {
		return this.ABOUTSECTIONS[index] as AboutSectionType;
	}

	//** Get the index by section */
	private _getIndexBySection(section: AboutSectionType): number {
		for (let i = 0; i < this.ABOUTSECTIONS.length; i++) {
			if (this.ABOUTSECTIONS[i] === section) {
				return i;
			}
		}
		return -1;
	}

	//** Animate across to subsection */
	private _animateToSubsection(direction: number, oldSectionType: AboutSectionType): void {
		if (this._$subsections[oldSectionType]) {
			this._tweens.sectionOld = gsap.TweenMax.to(this._$subsections[oldSectionType], 0.4, {
				autoAlpha: 0,
				ease: Config.linearEase,
				onComplete: () => {
					this._scrollbar.resetToZero();
					this._hideSubsection(this._$subsections[oldSectionType]);
				}
			});
		}

		this._tweens.sectionNew = gsap.TweenMax.fromTo(
			this._$subsections[this._aboutSection],
			0.6,
			{ autoAlpha: 0 },
			{
				autoAlpha: 1,
				delay: 0.4,
				ease: Config.linearEase,
				onStart: () => {
					this._showSubsection(this._$subsections[this._aboutSection]);
					this._changeScrollFocus();
					this.resize();
				}
			}
		);
	}

	private _hideSubsection($target: HTMLElement): void {
		if ($target) {
			this.DOM.removeClass($target, '-active');
			$target.style.display = 'none';
		}
	}

	private _showSubsection($target: HTMLElement): void {
		if (!$target) {
			console.warn(`Cant' run AboutController._showSubsection() as $target is not set`);
			return;
		}

		$target.style.display = 'block';
		this.DOM.addClass($target, '-active');
	}

	/** 
	/*	Change the scrollbar focus 
	/*	Animate the scrollbar between states so its a bit smoother 
	*/
	private _changeScrollFocus(): void {
		if (this._$subsections[this._aboutSection]) {
			gsap.TweenMax.set(this._$subsections[this._aboutSection], { y: 0 });
			//Containers are absolute so have no height, sp get the content inside:
			let $scrollbarHeightTarget: HTMLElement =
				this._$subsections[this._aboutSection].querySelector('.info__subsection__content');
			this._scrollbar.setFocus(this._$subsections[this._aboutSection], 0.5, $scrollbarHeightTarget);
			this._scrollbar.setActive(true);

			this._animateCircleLoaderDown();
			this._lockScrollUpdate = true;

			setTimeout(() => {
				this._lockScrollUpdate = false;
			}, 500);
		}
	}

	/** Reset anything that is happening */
	private _resetIntervalsAndAnimations(): void {
		Object.keys(this._tweens).forEach((key: string) => {
			this._tweens[key].kill();
		});
		Object.keys(this._timeouts).forEach((key: string) => {
			clearTimeout(this._timeouts[key]);
		});
		Object.keys(this._intervals).forEach((key: string) => {
			clearInterval(this._intervals[key]);
		});
	}

	private _animateCircleLoaderDown() {
		let tweenOb = { value: this._scrollProgress };

		gsap.TweenMax.to(tweenOb, 0.5, {
			value: 0,
			onUpdate: () => {
				this._scrollProgress = tweenOb.value;
				this._setScrollProgress(tweenOb.value);
			}
		});
	}

	private _setScrollProgress(scrollProgress: number, force: boolean = true) {
		if (!this._active && !force) {
			return;
		}

		if (scrollProgress < 0.02) {
			scrollProgress = 0;
		}

		if (scrollProgress > 0.98) {
			scrollProgress = 1;
		}

		console.log('scrollProgress', scrollProgress);

		let radius25PxDashArrayLength = 157.079632679;
		let dashoffset = Math.round(radius25PxDashArrayLength - radius25PxDashArrayLength * scrollProgress);

		if (dashoffset == 1) {
			dashoffset = 0;
		}

		fastdom.mutate(() => {
			this._$closeButtonSVG.style.setProperty('stroke-dashoffset', dashoffset + '');
		});
	}
}
